import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useCourtBooking } from "../context/courtBookingContext";
import { pubsub, PubSubKeys } from "../utils/pubsub";

const PrivateRoute = ({ children }: any) => {
  const { onLogOut } = useCourtBooking();

  useEffect(() => {
    const unsubscribe = pubsub.subscribe<string>(PubSubKeys.LOGOUT, (data) => {
      onLogOut(true);
    });
    return unsubscribe;
  }, [onLogOut]);

  const { isAuthenticated } = useCourtBooking();
  const { pathname } = useLocation();

  console.log(pathname);

  if (isAuthenticated === null) {
    return <Navigate to={`${pathname}`} />;
  }

  if (!isAuthenticated) {
    return <Navigate to={"/get-started"} />;
  }

  return children;
};

export default PrivateRoute;
